import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';

import Wrapper from './Wrapper';

export default class PublicRoute extends Component {
  render() {
    const { component: Component, condition, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={(props) =>
          condition ? <Wrapper {...rest} {...props} component={Component} /> : <Redirect to={'/app/home'} />
        }
      />
    );
  }
}
